import { lazy } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

const ApiPortalPage = lazy(() => import("@/pages/api-portal/ApiPortalPage"));
const ApiClientsPage = lazy(() => import("@/pages/api-portal/ApiClientsPage"));
const ApiDocsPage = lazy(() => import("@/pages/api-portal/ApiDocsPage"));
const ApiSandboxPage = lazy(() => import("@/pages/api-portal/ApiSandboxPage"));
const ApiUsagePage = lazy(() => import("@/pages/api-portal/ApiUsagePage"));

export function ApiPortalRoutes() {
  return (
    <>
      <Route path="/api-portal" element={<ProtectedRoute><ApiPortalPage /></ProtectedRoute>} />
      <Route path="/api-portal/clients" element={<ProtectedRoute><ApiClientsPage /></ProtectedRoute>} />
      <Route path="/api-portal/docs" element={<ProtectedRoute><ApiDocsPage /></ProtectedRoute>} />
      <Route path="/api-portal/sandbox" element={<ProtectedRoute><ApiSandboxPage /></ProtectedRoute>} />
      <Route path="/api-portal/usage" element={<ProtectedRoute><ApiUsagePage /></ProtectedRoute>} />
    </>
  );
}
